import React from 'react';

const CorporateProjectCitationChip = ({ activeCitation, citation, isPdfSource, onOpen }) => {
  if (!citation || !isPdfSource) return null;

  return (
    <button
      type="button"
      className={`citation-chip ${activeCitation?.id === citation.id ? 'active' : ''}`}
      title={citation.quote}
      aria-label={`View source citation on page ${citation.page}`}
      onClick={() => onOpen(citation.id)}
    >
      ⊙ p.{citation.page}
    </button>
  );
};

export default CorporateProjectCitationChip;
